export default "__VITE_ASSET__2ZxGvDRk__"